import { gql } from '@apollo/client';

export const GET_PERMISSION_PACKAGE_DETAIL_BY_ID = gql`
  query GetPermissionPackageDetailById($id: Long!) {
    getPermissionPackageDetailById(id: $id) {
      success
      message
      data {
        id
        name
        description
        resources
        createdAt
        updatedAt
      }
    }
  }
`;

export interface PermissionPackageDetailData {
  id: number | string;
  name: string;
  description?: string | null;
  resources: string[];
  createdAt?: number | null;
  updatedAt?: number | null;
}

export interface GetPermissionPackageDetailByIdResponse {
  getPermissionPackageDetailById: {
    success: boolean;
    message: string;
    data?: PermissionPackageDetailData | null;
  };
}

export interface GetPermissionPackageDetailByIdVariables {
  id: number;
}
